<script lang="ts">
import { computed } from "vue";
import { BTag } from "buefy";
import "@/style/components/TagsInfos.scss";
import TitleCardWithLimitLength from "@/components/common/TitleCardWithLimitLength.vue";
import { GenericTag, LocalTag } from "@/types/front/LocalTag";

export default {
  name: "TagsInfos",
  components: { TitleCardWithLimitLength, BTag },
  props: {
    tagsColumn: {
      type: Object,
      default: () => ({}),
    },
    infoParent: {
      type: Object,
    },
    tagsMenu: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    function getLocale(tag: GenericTag) {
      if (
        tag.tagName !== "ORDER_TAG"
        && tag.tagName !== "DATA_TAG"
        && tag.tagName !== "REFERENCE_TAG"
      ) {
        return props.tagsColumn[tag.tagName]?.localName
          ? props.tagsColumn[tag.tagName].localName
          : tag.tagName;
      }
    }

    function isPresent(tag: LocalTag) {
      tag = new LocalTag(tag);
      return (
        tag
        && tag.tagDefinition !== "ORDER_TAG"
        && tag.tagDefinition !== "NO_TAG"
        && tag.findTagInTagList(props.tagsColumn)
      );
    }

    function isSelected(tag: LocalTag) {
      return isPresent(tag) && tag.findTagInTagList(props.tagsColumn).selected;
    }

    function presenceTag(tag: LocalTag) {
      return isPresent(tag) ? "is-primary is-light" : "is-warning is-light";
    }

    // eslint-disable-next-line vue/return-in-computed-property
    const tagsListParent = computed(() => {
      if (props.infoParent) {
        if (props.infoParent.localtags) {
          return props.infoParent.localtags;
        }
        else if (props.infoParent.tags) {
          return props.infoParent.tags;
        }
      }
      else {
        return [];
      }
    });

    const tagInListParent = computed(
      () => props.tagsMenu && tagsListParent.value && tagsListParent.value.filter(isPresent),
    );
    const tagInInfoParent = computed(
      () => props.tagsMenu && props?.infoParent && props?.infoParent?.tags.filter((tag: LocalTag) => tag.tagDefinition !== "DATA_TAG"),
    );
    const noMenuTag = computed(
      () =>
        !props.tagsMenu
        && Object.keys(props.tagsColumn).length !== 0
        && props.infoParent
        && props.infoParent.tags,
    );
    // eslint-disable-next-line vue/return-in-computed-property
    const infoParentDisplay = computed(() => {
      if (props.infoParent) {
        if (props.infoParent.label) {
          return props.infoParent.label;
        }
        else if (props.infoParent.title) {
          return props.infoParent.title;
        }
      }
      else return "";
    });

    return {
      getLocale,
      presenceTag,
      tagInListParent,
      tagInInfoParent,
      noMenuTag,
      infoParentDisplay,
      isSelected,
      isPresent,
    };
  },
};
</script>

<template>
  <div>
    <div
      v-if="tagInListParent && tagInListParent.length"
      class="columns"
    >
      <span
        v-for="tag in tagInListParent"
        :key="tag.tagName"
        class="tagSpan column"
      >
        <b-tag
          :class="presenceTag(tag)"
          :aria-label="getLocale(tag)"
        >
          {{ getLocale(tag) }}
        </b-tag>
      </span>
    </div>
    <div
      v-else-if="tagInInfoParent && tagInInfoParent.length"
      class="columns"
    >
      <div
        v-for="tag in tagInInfoParent.filter((tag: any) => tag.tagDefinition === 'DOMAIN_TAG')"
        :key="tag.tagName"
        class="tagSpan"
      >
        <b-tag
          class="is-primary is-light"
          :aria-label="getLocale(tag)"
        >
          <TitleCardWithLimitLength
            v-if="getLocale(tag)"
            :limit="10"
            :local-name="getLocale(tag)"
            :position="'is-right'"
          />
        </b-tag>
      </div>
    </div>
    <div
      v-else-if="noMenuTag"
      class="columns"
    >
      <span
        v-for="tag in noMenuTag.filter((tag: any) => tag?.tagDefinition === 'DOMAIN_TAG')"
        :key="tag.tagName"
        class="tagSpanLeft"
      >
        <b-tag
          v-if="isPresent(tag)"
          :class="presenceTag(tag)"
          :aria-label="getLocale(tag)"
        >
          {{ getLocale(tag) }}
        </b-tag>
      </span>
    </div>
  </div>
</template>
